import { createFileRoute, useParams } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"
import { LessonPage } from "@/components/pages/agenda/LessonPage"

export const Route = createFileRoute("/agenda/les/$lessonId")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "calendar"),
})

function RouteComponent() {
  const { lessonId } = useParams({
    from: "/agenda/les/$lessonId",
  })

  return <LessonPage lessonId={Number(lessonId)} />
}
